import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './vendors/icofont.css';
import './vendors/font-awesome.css';
import './vendors/themify.css';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/tr';
import'./Global.css'
import './index.css'
import '@inovua/reactdatagrid-community/index.css'

// Dayjs ayarları
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('tr');
dayjs.tz.setDefault("Europe/Istanbul");

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

